"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RolledServices = void 0;
const AWS = require("aws-sdk");
const setup_1 = require("../setup");
const configuration_1 = require("./../configuration");
class RolledServices {
    constructor() {
        AWS.config.region = configuration_1.Configuration.region();
        this.sts = new AWS.STS({ apiVersion: configuration_1.Configuration.apiVersion() });
        this.logger = setup_1.LoggingService.getLogger("@vacasa/secrets-manager");
    }
    async getSecretsManager() {
        const params = {
            RoleArn: process.env.ROLE_ARN,
            RoleSessionName: process.env.ROLE_SESSION_NAME,
        };
        try {
            const data = await this.sts.assumeRole(params).promise();
            AWS.config.update({
                apiVersion: configuration_1.Configuration.apiVersion(),
                accessKeyId: data.Credentials.AccessKeyId,
                secretAccessKey: data.Credentials.SecretAccessKey,
                sessionToken: data.Credentials.SessionToken,
            });
            return new AWS.SecretsManager({ apiVersion: configuration_1.Configuration.apiVersion() });
        }
        catch (err) {
            this.logger.error(`assumeRole error: ${err.code} - ${err.message}`);
            throw err;
        }
    }
}
exports.RolledServices = RolledServices;
//# sourceMappingURL=rolled.services.js.map